import angular from 'angular';
import {
  DownloadElementButtonComponent,
  DownloadElementLabelComponent,
  DownloadElementLinkComponent,
} from './download-element-component';

import AsyncDownloadComponent from './components/async-download/async-download-component';

export default angular
  .module('download-element', [])
  .component('downloadAsync', new AsyncDownloadComponent())
  .component('downloadButton', new DownloadElementButtonComponent())
  .component('downloadLink', new DownloadElementLinkComponent())
  .component('downloadLabel', new DownloadElementLabelComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/download-element/download-element-module.js